import {ref} from "vue";


import epl from '@/assets/images/leagues/england.png'
import laliga from '@/assets/images/leagues/spain.png'
import ligue1 from '@/assets/images/leagues/france.png'
import seriea from '@/assets/images/leagues/italy.png'
import bundesliga from '@/assets/images/leagues/germany.png'

const teamsNavigate = ref([
    {
        short_name: 'АПЛ',
        full_name: 'Английская Премьер-лига',
        logo: epl,
        clubs: [
            {
                name: '«Манчестер Юнайтед»',
                en_name: 'Manchester United',
                colours: ['#DA020E', '#FFE500']
            },
            {
                name: '«Манчестер Сити»',
                en_name: 'Manchester City',
                colours: ['#6CABDD', '#1C2C5B']
            },
            {
                name: '«Ливерпуль»',
                en_name: 'Liverpool',
                colours: ['#C8102E', '#00B2A9']
            },
            {
                name: '«Челси»',
                en_name: 'Chelsea',
                colours: ['#034694', '#DBA111']
            },
            {
                name: '«Арсенал»',
                en_name: 'Arsenal',
                colours: ['#EF0107', '#FFFFFF']
            },
            {
                name: '«Тоттенхэм»',
                en_name: 'Tottenham Hotspur',
                colours: ['#FFFFFF', '#132257']
            },
            {
                name: '«Ньюкасл Юнайтед»',
                en_name: 'Newcastle United',
                colours: ['#FFFFFF', '#241F20']
            }
        ]
    },

    {
        short_name: 'Ла Лига',
        full_name: 'Испанская Ла Лига',
        logo: laliga,
        clubs: [
            {
                name: '«Реал Мадрид»',
                en_name: 'Real Madrid',
                colours: ['#FFFFFF', '#FEBE10']
            },
            {
                name: '«Барселона»',
                en_name: 'Barcelona',
                colours: ['#A50044', '#004D98']
            },
            {
                name: '«Атлетико Мадрид»',
                en_name: 'Atletico Madrid',
                colours: ['#E8151E', '#FFFFFF']
            },
            {
                name: '«Атлетик Бильбао»',
                en_name: 'Athletic Bilbao',
                colours: ['#EE2523', '#FFFFFF']
            },
            {
                name: '«Валенсия»',
                en_name: 'Valencia',
                colours: ['#FFB000', '#FFFFFF']
            },
            {
                name: '«Севилья»',
                en_name: 'Sevilla',
                colours: ['#FFFFFF', '#D71920']
            },
            {
                name: '«Вильярреал»',
                en_name: 'Villarreal',
                colours: ['#FFF200', '#005187']
            }
        ]
    },

    {
        short_name: 'Бундеслига',
        full_name: 'Немецкая Бундеслига',
        logo: bundesliga,
        clubs: [
            {
                name: '«Бавария»',
                en_name: 'Bayern Munich',
                colours: ['#DC052D', '#0066B2']
            },
            {
                name: '«Боруссия Дортмунд»',
                en_name: 'Borussia Dortmund',
                colours: ['#FDE100', '#000000']
            },
            {
                name: '«Байер»',
                en_name: 'Bayer Leverkusen',
                colours: ['#E32221', '#000000']
            },
            {
                name: '«РБ Лейпциг»',
                en_name: 'RB Leipzig',
                colours: ['#DD0741', '#FFFFFF']
            },
            {
                name: '«Штутгарт»',
                en_name: 'VfB Stuttgart',
                colours: ['#FFFFFF', '#E32219']
            },
            {
                name: '«Шальке 04»',
                en_name: 'Schalke 04',
                colours: ['#004D9D', '#FFFFFF']
            },
            {
                name: '«Айнтрахт Франкфурт»',
                en_name: 'Eintracht Frankfurt',
                colours: ['#000000', '#E1000F']
            }
        ]
    },

    {
        short_name: 'Серия А',
        full_name: 'Итальянская Серия А',
        logo: seriea,
        clubs: [
            {
                name: '«Ювентус»',
                en_name: 'Juventus',
                colours: ['#000000', '#FFFFFF']
            },
            {
                name: '«Интер»',
                en_name: 'Inter Milan',
                colours: ['#0068A8', '#000000']
            },
            {
                name: '«Милан»',
                en_name: 'AC Milan',
                colours: ['#000000', '#D80809']
            },
            {
                name: '«Наполи»',
                en_name: 'Napoli',
                colours: ['#12A0D7', '#FFFFFF']
            },
            {
                name: '«Рома»',
                en_name: 'AS Roma',
                colours: ['#8E1F2D', '#F7B5CD']
            },
            {
                name: '«Лацио»',
                en_name: 'Lazio',
                colours: ['#87D8F7', '#FFFFFF']
            },
            {
                name: '«Фиорентина»',
                en_name: 'Fiorentina',
                colours: ['#482E92', '#FFFFFF']
            }
        ]
    },

    {
        short_name: 'Лига 1',
        full_name: 'Французская Лига 1',
        logo: ligue1,
        clubs: [
            {
                name: '«ПСЖ»',
                en_name: 'Paris Saint-Germain',
                colours: ['#004170', '#DA291C']
            },
            {
                name: '«Марсель»',
                en_name: 'Olympique Marseille',
                colours: ['#2FA7DF', '#FFFFFF']
            },
            {
                name: '«Лион»',
                en_name: 'Olympique Lyonnais',
                colours: ['#1D428A', '#FFFFFF']
            },
            {
                name: '«Монако»',
                en_name: 'AS Monaco',
                colours: ['#EF0000', '#FFFFFF']
            },
            {
                name: '«Лилль»',
                en_name: 'Lille OSC',
                colours: ['#E30613', '#FFFFFF']
            },
            {
                name: '«Ренн»',
                en_name: 'Rennes',
                colours: ['#E30613', '#000000']
            },
            {
                name: '«Ницца»',
                en_name: 'Nice',
                colours: ['#000000', '#FF0000']
            }
        ]
    },

    {
        short_name: 'Другие лиги',
        full_name: 'Остальной мир',
        clubs: [
            {
                name: '«Бенфика»',
                en_name: 'Benfica',
                colours: ['#FF0000', '#FFFFFF']
            },
            {
                name: '«Порту»',
                en_name: 'Porto',
                colours: ['#003DA5', '#FFFFFF']
            },
            {
                name: '«Спортинг»',
                en_name: 'Sporting CP',
                colours: ['#00853F', '#FFFFFF']
            },
            {
                name: '«Аякс»',
                en_name: 'Ajax',
                colours: ['#D2122E', '#FFFFFF']
            },
            {
                name: '«ПСВ»',
                en_name: 'PSV Eindhoven',
                colours: ['#FF0000', '#FFFFFF']
            },
            {
                name: '«Фейеноорд»',
                en_name: 'Feyenoord',
                colours: ['#E30613', '#FFFFFF']
            },
            {
                name: '«Галатасарай»',
                en_name: 'Galatasaray',
                colours: ['#FDB913', '#A90432']
            },
            {
                name: '«Фенербахче»',
                en_name: 'Fenerbahce',
                colours: ['#FFFF00', '#002B5C']
            }
        ]
    },

    {
        short_name: 'РПЛ',
        full_name: 'Российская Премьер-лига',
        clubs: [
            {
                name: '«Зенит»',
                en_name: 'Zenit Saint Petersburg',
                colours: ['#00529C', '#FFFFFF']
            },
            {
                name: '«Спартак Москва»',
                en_name: 'Spartak Moscow',
                colours: ['#E30613', '#FFFFFF']
            },
            {
                name: '«ЦСКА Москва»',
                en_name: 'CSKA Moscow',
                colours: ['#0039A6', '#E30613']
            },
            {
                name: '«Локомотив Москва»',
                en_name: 'Lokomotiv Moscow',
                colours: ['#006633', '#E30613']
            },
            {
                name: '«Динамо Москва»',
                en_name: 'Dynamo Moscow',
                colours: ['#0050A4', '#FFFFFF']
            },
            {
                name: '«Краснодар»',
                en_name: 'Krasnodar',
                colours: ['#008A3D', '#FFFFFF']
            },
            {
                name: '«Ростов»',
                en_name: 'Rostov',
                colours: ['#FFD700', '#003399']
            }
        ]
    },

    {
        short_name: 'Сборные',
        full_name: 'Международный футбол',
        clubs: [
            {
                name: 'Сборная Аргентины',
                en_name: 'Argentina National Team',
                colours: ['#75AADB', '#FFFFFF']
            },
            {
                name: 'Сборная Бразилии',
                en_name: 'Brazil National Team',
                colours: ['#FFDF00', '#009C3B']
            },
            {
                name: 'Сборная Франции',
                en_name: 'France National Team',
                colours: ['#0055A4', '#EF4135']
            },
            {
                name: 'Сборная Англии',
                en_name: 'England National Team',
                colours: ['#FFFFFF', '#C8102E']
            },
            {
                name: 'Сборная Германии',
                en_name: 'Germany National Team',
                colours: ['#FFFFFF', '#B0A55F']
            },
            {
                name: 'Сборная Испании',
                en_name: 'Spain National Team',
                colours: ['#AA151B', '#F1BF00']
            },
            {
                name: 'Сборная Италии',
                en_name: 'Italy National Team',
                colours: ['#0066B3', '#FFFFFF']
            },
            {
                name: 'Сборная Португалии',
                en_name: 'Portugal National Team',
                colours: ['#FF0000', '#006600']
            }
        ]
    }
]);

export default teamsNavigate